import { League } from '../../../../types/sport';
import { PREMIER_LEAGUE_TEAMS } from './data/premier-league-teams';
import { LA_LIGA_TEAMS } from './data/la-liga-teams';

export const PLAYER_VS_PLAYER_LEAGUES: League[] = [
  {
    value: 'premier-league',
    label: 'Premier League',
    teams: PREMIER_LEAGUE_TEAMS
  },
  {
    value: 'la-liga',
    label: 'La Liga',
    teams: LA_LIGA_TEAMS
  }
];
